module.exports = __webpack_public_path__ + "static/media/halasz_fishinf_app_mockup.3155d6f8.png";